export const FORM_BASE = 'individualCoachForm/FORM_BASE';
export const FORM_SUBMITTED = 'individualCoachForm/FORM_SUBMITTED';
export const FORM_SUBMITTING = 'individualCoachForm/FORM_SUBMITTING';
export const FORM_SET = 'individualCoachForm/FORM_SET';